export const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    marginTop: '20px'
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw'
  },
  button: {
    margin: '0px 20px 20px 20px',
    width: '90%',
    maxWidth: '500px',
    borderRadius: '50px',
    textTransform: 'none',
    minHeight: '80px'
  }
}



// WEBPACK FOOTER //
// ./src/pages/Hero/styles.js